import { render, staticRenderFns } from "./ConsultaPreFaturaDespesaFilterBar.vue?vue&type=template&id=4b1966f7"
import script from "./ConsultaPreFaturaDespesaFilterBar.vue?vue&type=script&lang=js"
export * from "./ConsultaPreFaturaDespesaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports